import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Item {
  code: string;
  desc: string;
}

interface PosItem {
  code: string;
  desc: string;
  region: string;
}
interface LanguageState {
  fr: Item[];
  en: Item[];
}

interface PosLanguageState {
  fr: PosItem[];
  en: PosItem[];
}

export interface InitialRegistrationState {
  pos: PosLanguageState;
  businessModel: LanguageState;
  customerTypes: LanguageState;
  apiSchemas: LanguageState;
  supportedFlow: LanguageState;
  isSubmitting: boolean;
  submitSuccess: boolean;
  submitError: any;
}

const initialState: InitialRegistrationState = {
  pos: {
    fr: [],
    en: []
  },
  businessModel: {
    fr: [],
    en: []
  },
  customerTypes: {
    fr: [],
    en: []
  },
  apiSchemas: {
    fr: [],
    en: []
  },
  supportedFlow: {
    fr: [],
    en: []
  },
  isSubmitting: false,
  submitSuccess: false,
  submitError: null
};

const sellerRegistrationSlice = createSlice({
  name: 'sellerRegistration',
  initialState,
  reducers: {
    getAllRegistrationData: (state) => {},
    setAllRegistrationData: (state, action: any) => {
      // Only reset and fill if data exists
      if (action?.payload) {
        state.pos = { fr: [], en: [] };
        state.businessModel = { fr: [], en: [] };
        state.customerTypes = { fr: [], en: [] };
        state.apiSchemas = { fr: [], en: [] };
        state.supportedFlow = { fr: [], en: [] };
        (action.payload.posType || []).forEach(
          ({ country, pos_code, pays, region, region_fr }) => {
            state.pos.en.push({
              code: pos_code,
              desc: country,
              region: region
            });
            state.pos.fr.push({
              code: pos_code,
              desc: pays,
              region: region_fr
            });
          }
        );

        (action.payload.businessModel || []).forEach(
          ({
            business_model_id,
            business_model_type,
            business_model_type_fr
          }) => {
            state.businessModel.en.push({
              code: business_model_id,
              desc: business_model_type
            });
            state.businessModel.fr.push({
              code: business_model_id,
              desc: business_model_type_fr
            });
          }
        );

        (action.payload.customerTypes || []).forEach(
          ({ customer_type_id, customer_type, customer_type_fr }) => {
            state.customerTypes.en.push({
              code: customer_type_id,
              desc: customer_type
            });
            state.customerTypes.fr.push({
              code: customer_type_id,
              desc: customer_type_fr
            });
          }
        );

        (action.payload.apiSchema || []).forEach(
          ({
            api_schema_version,
            api_schema_description,
            api_schema_description_fr
          }) => {
            state.apiSchemas.en.push({
              code: api_schema_version,
              desc: api_schema_description
            });
            state.apiSchemas.fr.push({
              code: api_schema_version,
              desc: api_schema_description_fr
            });
          }
        );

        (action.payload.supportedFlow || []).forEach(
          ({
            supported_flow_id,
            supported_flow_desc,
            supported_flow_desc_fr
          }) => {
            state.supportedFlow.en.push({
              code: supported_flow_id,
              desc: supported_flow_desc
            });
            state.supportedFlow.fr.push({
              code: supported_flow_id,
              desc: supported_flow_desc_fr
            });
          }
        );

        // state.submitError = false;
      }
    },
    submitRequest: (state, action: PayloadAction<any>) => {
      state.isSubmitting = true;
      state.submitError = null;
    },
    submitSuccess: (state) => {
      state.isSubmitting = false;
      state.submitSuccess = true;
    },
    submitFailure: (state, action: PayloadAction<any>) => {
      state.isSubmitting = false;
      state.submitError = action.payload;
    },
    resetSuccess: (state) => {
      state.submitSuccess = false;
    },
    resetSubmitError: (state) => {
      state.submitError = null;
    }
  }
});

export const {
  getAllRegistrationData,
  setAllRegistrationData,
  submitRequest,
  submitSuccess,
  submitFailure,
  resetSuccess,
  resetSubmitError
} = sellerRegistrationSlice.actions;
export default sellerRegistrationSlice.reducer;